import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const toastAlert = (msg, form = '', isTheme = true) => {
  switch (form) {
    case 'success':
      toast.success(msg, { autoClose: 1000, theme: isTheme ? 'colored' : 'auto' });
      break;
    case 'error':
      toast.error(msg, { autoClose: 1000, theme: isTheme ? 'colored' : 'auto' });
      break;
    case 'info':
      toast.info(msg, { autoClose: 1000, theme: isTheme ? 'colored' : 'auto' });
      break;
    case 'warning':
      toast.warning(msg, { autoClose: 1000, theme: isTheme ? 'colored' : 'auto' });
      break;
    default:
      toast(msg, { autoClose: 1000, theme: 'auto' });
      break;
  }
};
const FORM = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

export { toastAlert, FORM };
